import type { ComponentSchema } from '../../../../../schema-types'

/** Khelaghor order complete: thank-you card, order summary, timeline and continue shopping. Keys follow lightings-1. */
export const schema: ComponentSchema = {
  type: 'order-success',
  label: 'Order complete',
  description: 'Thank-you message with the order number, date, total, payment and order details.',
  supportedPages: ['order-success'],
  variants: [{ id: 'v1', label: 'Thank-you card' }],
  commonFields: [
    { key: 'title', label: 'Thank-you title', type: 'localized-string', default: 'Thank you. Your order has been received.' },
    { key: 'message', label: 'Thank-you message', type: 'localized-text', default: 'We will call you to confirm your order before delivery.' },
    { key: 'errorTitle', label: 'Title when the order cannot be loaded', type: 'string', default: 'Your order was placed.' },
    { key: 'errorMessage', label: 'Message when the order cannot be loaded', type: 'string', default: 'We could not load the order details on this device, but your order was received.' },
    { key: 'viewOrderText', label: 'View order button text (signed-in shoppers)', type: 'string', default: 'View order' },
    { key: 'continueShoppingText', label: 'Continue shopping text', type: 'string', default: 'Continue shopping' },
    { key: 'continueShoppingLink', label: 'Continue shopping link', type: 'string', default: '/shop' },
  ],
}
